import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import scriptApi from "../../../data/api/scriptApi";
import scriptItemApi from "../../../data/api/scriptItemApi";
import { getAllScripts, getScriptItemsByScript } from "../../../data/getters";
import { addScriptItem } from "../../../data/store/actions/scriptStoreFunctions";
import {
  createScriptCopyMetadata,
  createScriptItemCopyData
} from "./scriptsListUtils";

export default function useScriptsListController({ onCreate }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCreate = useCallback(() => {
    onCreate();
  }, [onCreate]);

  const handleEdit = useCallback(
    (scriptId) => {
      navigate(`/scripts/${scriptId}`);
    },
    [navigate]
  );

  const handleDuplicate = useCallback(
    async (originalScript) => {
      try {
        const clonedScript = await dispatch(
          scriptApi.createScriptApi(createScriptCopyMetadata(originalScript))
        );

        const items = await dispatch(
          getScriptItemsByScript(originalScript.scriptId)
        );

        for (const item of items) {
          const createdItem = await dispatch(
            scriptItemApi.createScriptItemApi(
              createScriptItemCopyData(item, clonedScript.scriptId)
            )
          );

          dispatch(
            addScriptItem({
              ...createdItem,
              scriptId: createdItem.scriptId ?? clonedScript.scriptId,
              refScript: createdItem.refScriptId ?? createdItem.refScript
            })
          );
        }

        await dispatch(getAllScripts());
      } catch (error) {
        window.alert("Hiba a duplikálás során");
      }
    },
    [dispatch]
  );

  const handleDelete = useCallback(
    (scriptId) => dispatch(scriptApi.deleteScriptApi(scriptId)),
    [dispatch]
  );

  return {
    handleCreate,
    handleEdit,
    handleDuplicate,
    handleDelete
  };
}
